module.exports = "/_next/static/media/254f121be1b121f98db6efd11ea74d2f.svg";